import PropTypes from 'prop-types';
import React from 'react';

export const CartRow = ({ label, right }) => {
  return (
    <div className="ticket_class">
      <p className="leftside">{label}</p>
      <p className="rightside">{right}</p>
    </div>
  )
}

CartRow.propTypes = {
  item: PropTypes.object,
  currency: PropTypes.string,
}
